import React from 'react';
import useDfcSurface from '../../../../../hooks/useDfcSurface';
import useDfcVillageDesktop from '../../../../../hooks/useDfcVillageDesktop';
import { SkeletonBlock } from '../../../dfcVillage/style';
import { HeaderBar, HeaderRow, SkeletonActions } from './style';

/**
 * Loading skeleton for the DFC Fitness Village header.
 *
 * The shared white `HeaderSkeleton` flashes on the dark surface (plan §8.4); this variant
 * reuses the real header's `HeaderBar` chrome plus the surface-aware `SkeletonBlock` so both
 * light and dark render correctly and the layout does not shift when the real header arrives.
 * Widths mirror the canvas: 30/34px lockup, 34px round controls, 38px hamburger.
 */
const HeaderSkeleton: React.FC = () => {
  const surface = useDfcSurface();
  const isDesktop = useDfcVillageDesktop();

  return (
    <HeaderBar surface={surface} position="sticky" elevation={0} data-testid="dfc-header-skeleton">
      <HeaderRow>
        <SkeletonBlock
          surface={surface}
          h={isDesktop ? 34 : 30}
          w={isDesktop ? '160px' : '140px'}
          r={8}
        />

        {isDesktop && <SkeletonBlock surface={surface} h={16} w="260px" r={8} />}

        <SkeletonActions>
          <SkeletonBlock surface={surface} h={34} w="34px" r={999} />
          {isDesktop ? (
            <>
              <SkeletonBlock surface={surface} h={38} w="80px" r={999} />
              <SkeletonBlock surface={surface} h={38} w="120px" r={999} />
            </>
          ) : (
            <>
              <SkeletonBlock surface={surface} h={32} w="70px" r={999} />
              <SkeletonBlock surface={surface} h={38} w="38px" r={12} />
            </>
          )}
        </SkeletonActions>
      </HeaderRow>
    </HeaderBar>
  );
};

export default HeaderSkeleton;
